import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommonServices } from 'src/app/Common/CommonServices';
import { PlatformChargesClient, RoomOwnerAccountDetail, RoomOwnerPlatformCharge, User, WebinarSettlementDetail, WebinarSettlementDetailsGetDTO } from 'src/app/Services/WOWApi.Service';
import { CustomServiceService } from 'src/app/Services/custom-service.service';
import { openConfirmDialog } from 'src/app/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-create-settlement',
    templateUrl: './create-settlement.component.html',
    styleUrls: ['./create-settlement.component.css'],
    standalone: false
})
export class CreateSettlementComponent implements OnInit {
  settlementFeed: any = {};
  isMobileView = false;
  settlements: WebinarSettlementDetailsGetDTO[] = [];
  fileToUpload: any;
  isNewSettlement = true;
  settlementUpdateObj: WebinarSettlementDetail;
  activeAccout: RoomOwnerAccountDetail;
  platformCharge: RoomOwnerPlatformCharge;
  userDetails: User;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder,
    private dialogRef: MatDialogRef<CreateSettlementComponent>,
    private commonServices: CommonServices,
    private platformChargesClient: PlatformChargesClient,
    private customUploadService: CustomServiceService,
    private dialog: MatDialog
  ) {
    this.userDetails = JSON.parse(localStorage.getItem("UserInfo"));
    if (this.data !== undefined && this.data !== null && this.data.isNewSettlement === true) {
      this.settlements = this.data.settlements;
      this.isNewSettlement = this.data.isNewSettlement;
    }
    if (this.data !== undefined && this.data !== null && this.data.isNewSettlement === false) {
      this.settlementUpdateObj = this.data.settlementUpdateObj;
      this.isNewSettlement = this.data.isNewSettlement;
    }
    if (this.data !== undefined && this.data !== null && this.data.roomOwnerId > 0) {
      this.getRoomOwnerActiveAccountDetail(this.data.roomOwnerId);
      this.getPlatformCharge(this.data.roomOwnerId);
    }
  }

  ngOnInit(): void {
    //this.buildForm();
  }

  onCancel() {
    this.dialogRef.close(null);
  }

  onUpdateFile(event) {
    if (!event.target.files)
      return;

    var mimeType = event.target.files[0].type;

    if (mimeType.match(/image\/*/) == null) {
      this.commonServices.showMessage("Error", "Only images are supported.");
      return;
    }
    this.fileToUpload = event.target.files[0];
    console.log(this.fileToUpload);
  }

  getRoomOwnerActiveAccountDetail(roomOwnerId: number) {
    this.platformChargesClient.getRoomOwnerActiveAccount(roomOwnerId).subscribe(res => {
       if (res === null || res === undefined) {
        this.commonServices.showMessage('error', `Accounts details for ${roomOwnerId} has not been configured, Kindly ensure the room owner completes the configuration.`, 15);
        this.dialogRef.close(null);
      }
      this.activeAccout = res;
    }, error => {
      this.commonServices.showMessage('error', error, 5);
    })
  }

  getPlatformCharge(roomOwnerId: number) {
    this.platformChargesClient.getRoomOwnerPlatformCharge(roomOwnerId).subscribe(res => {
      if (res.percentage === null || res.percentage === undefined) {
        this.commonServices.showMessage('error', `Platform Charges has not been configured for ${roomOwnerId}, please complete the configuration to proceed.`, 15);
        this.dialogRef.close(null);
      }
      this.platformCharge = res;
    }, error => {
      this.commonServices.showMessage('error', error, 4);
    })
  }

  totalAmountToBeSettled() {
    let amount = 0;
    this.settlements.map(x => {
      amount += x.toBeSettledAmountAfterPlatformChargesDeduction
    });
    return amount;
  }

  onUpdate() {
    if (this.settlementFeed.transactionNumber === null || this.settlementFeed.transactionNumber === undefined || this.settlementFeed.transactionNumber.trim() === '') {
      this.commonServices.showMessage('error', 'Transaction number is mandatory.', 5);
      return;
    }
    if (this.settlementFeed.settledOn === null || this.settlementFeed.settledOn === undefined || this.settlementFeed.settledOn === '') {
      this.commonServices.showMessage('error', 'Settled On is mandatory.', 5);
      return;
    }
    if (this.fileToUpload === null || this.fileToUpload === undefined || this.fileToUpload === '') {
      this.commonServices.showMessage('error', 'Settlement payment proof is mandatory.', 5);
      return;
    }
    openConfirmDialog(this.dialog, {
        message: `Are you sure, you want to process the settlemetn?`,
        buttonText: {
          ok: 'Yes, Process',
          cancel: 'No, Cancel'
        }
    }).afterClosed().subscribe(res => {
      if (res ===  true) {
        const settlmentObjs: WebinarSettlementDetail[] = [];
        if (this.isNewSettlement) {
          this.settlements.map((x: WebinarSettlementDetailsGetDTO) => {
            const obj: any = {
              settlementId: 0,
              webinarId: x.webinarId,
              webinarRoomOwnerId: this.data.roomOwnerId,
              roomOwnerAccountDetailId: this.activeAccout.accountId,
              platformChargesPercentage: this.platformCharge.percentage,
              platformCharges: x.platformChargesAmount,
              settledAmount: x.toBeSettledAmountAfterPlatformChargesDeduction,
              settledFromBank: 'WoW-Admin',
              settledOn: this.settlementFeed.settledOn,
              transactionNumber: this.settlementFeed.transactionNumber
            }
            settlmentObjs.push(obj);
          });
          console.log(settlmentObjs)
          this.platformChargesClient.addWebinarSettlement(this.userDetails.id , settlmentObjs).subscribe(res => {
            if (res !== null && res.length > 0) {
              var ids = res.join(',');        
              this.customUploadService.uploadWebinarAccountSettlementFileUpload(this.fileToUpload, ids).subscribe(res => {
                if (res === true) {
                  this.commonServices.showMessage('success', 'Webinar Settlement Created successfuylly.', 4);
                  this.dialogRef.close({action: 'success', objs: this.settlements});
                } else {
                  this.commonServices.showMessage('error', 'Could not upload the file', 10);
                }
              }, error => {
                this.commonServices.showMessage('error', error, 5);
              });
            } else {
              this.commonServices.showMessage('error', 'Could not create settlement due to server error', 10);
            }
          }, error => {
            this.commonServices.showMessage('error', error, 4);
          })
        } else {
          // to be implemented for update
        }
      }
    });
  }

}
